import {
  Component,
  EventEmitter,
  Input,
  Output,
  OnInit,
  ViewChild,
  OnChanges,
  ViewChildren,
} from '@angular/core';
import {
  animate,
  state,
  style,
  transition,
  trigger,
} from '@angular/animations';

import { EntityManagerProvider } from '../../providers/entity-manager-provider/entity-manager-provider';
import { SeccionPlano, PlanoComponent } from 'interiores-mapa';
import { zoomCenterCoordsPlano } from 'interiores-mapa/dist/zoomCenterCoordsPlano';
import { ServiciosWebServiceProvider } from '../../providers/web-service-service/servicios-web-service';
import { AuthenticationService } from '../../providers/authentication/authentication.service';
import { AlaFormulario } from '../../domain/AlaFormulario';
import { ServiciosStatsProvider } from '../../providers/web-service-service/servicios-stats';
import { IdiomaCalendario } from '../../domain/IdiomaCalendatio';
import { TranslateService } from '../../../../node_modules/ng2-translate';
import { Message } from '_debugger';

type PaneType = 'left' | 'right';

const COLORES2 = [
  [255, 14, 240],
  [255, 160, 0],
  [5, 0, 255],
];

const COLORES = [
  [255, 0, 20],
  [215, 255, 0],
  [5, 0, 255],
];

const VISITANODOS = 0;
const VISITAUSUARIOS = 1;
const BUSCACONTENIDO = 2;

@Component({
  selector: 'app-ocupacionchart',
  templateUrl: './ocupacionChart.component.html',
  styleUrls: ['./ocupacionChart.component.scss'],
  providers: [EntityManagerProvider]
})

export class AppOcupacionChartComponent implements OnInit, OnChanges {
  // @ViewChild('contenedorPlano') contenedorPlano: any;
  @ViewChild('plano') plano: PlanoComponent;
  @ViewChildren('contenedorPlano') contenedoresPlano;

	msgs: Message[] = [];
	spinner: HTMLElement;
	blockUI: HTMLElement;

  // Filtros fecha
  dateRange = {
    inicio: null,
    fin: null,
    lastMinutes: null
  };
  filtroDesde;
  filtroHasta;
  startHourDefault: any;
	finHourDefault: any;

  // Plano
  listaAlasFormulario = []; // Lista de las AlaFormulario
  numAla = 0; // Indice de AlaFormularioSeleccionada
  alasDrop = []; // Lista de Alas para el DropDown
  alasSVG = []; // Lista SVGs de las Alas

  secciones = [];
  seccionesPre = [];
  seccionesHot = {};

  nodosDeLaConsulta = [];

  zoomIniciado;
  zoomAndCenterCoords;
  anchoMapa;
  altoMapa;

  planoData = {
    width: 0,
    height: 0,
  };


  // Seleccion de rango de fechas
  rangoFechasSeleccionado;
  numTipo;

  // stats
  consulta = [];
  visitasNodo = [];
  visitasSeccion = [];

  //  Variables que alimentan lib-mapa-calor
  pathPlano = '';
  puntos = {}; // Es un mapa con key pathPlano y value point[]
  radius = 250;
  opacity = 0.5;
  scale = 0.3;
  useOpacity = true;
  maxRange = 0;

  idiomaCalendario: IdiomaCalendario;

  public positionDialogInfoInformeY: number;
	public positionDialogInfoInformeX: number;
	public dialogDescripcionInforme: boolean = false;

  constructor(
    public sws: ServiciosWebServiceProvider,
    public authenticationService: AuthenticationService,
    public statsService: ServiciosStatsProvider,
    private entityManagerProvider: EntityManagerProvider,
    private translate: TranslateService,
  ) {

    // Inicializamos Spinner
    this.spinner = document.getElementsByClassName('spinner-container')[0] as HTMLElement;
    this.spinner.style.display = 'none';

    this.blockUI = document.getElementsByClassName('blockUI')[0] as HTMLElement;
    this.blockUI.style.display = 'none';

		this.idiomaCalendario = new IdiomaCalendario();
		this.idiomaCalendario.firstDayOfWeek = 1;
		this.idiomaCalendario.dayNames = this.translate.instant('Calendario.dayNames');
		this.idiomaCalendario.dayNamesShort = this.translate.instant('Calendario.dayNamesShort');
		this.idiomaCalendario.dayNamesMin = this.translate.instant('Calendario.dayNamesMin');
		this.idiomaCalendario.monthNames = this.translate.instant('Calendario.monthNames');
		this.idiomaCalendario.monthNamesShort = this.translate.instant('Calendario.monthNamesShort');
		this.idiomaCalendario.today = this.translate.instant('Calendario.today');
		this.idiomaCalendario.clear = this.translate.instant('Calendario.clear');

    this.startHourDefault = new Date();
		this.startHourDefault.setHours(0, 0, 0, 0);
		this.finHourDefault = new Date();
		this.finHourDefault.setHours(23, 59, 59, 999);

  }


  ngOnInit(): void {
    console.log('Method ngOnInit.');
    this.cargarALAs('ngOnInit');
  }

  clickEventHandler(item, i){
    console.log(item);
    this.cambiarPlanta({value: i});
  }

  ngOnChanges() {
    console.log('Method ngOnChanges.');
    this.cargaSecciones();
    this.zoomIniciado = false;
  }

  onFechaAceptar(dt, calendar, columna, tipo) {
		console.log(calendar);
		const fecha = calendar.value ? calendar.value : new Date();
		// Preparamos los valores de los filtros
		if (tipo === 'Desde') {
			this.filtroDesde = fecha;
		}
		if (tipo === 'Hasta') {
			this.filtroHasta = fecha;
		}

		this.cargaSecciones();
		calendar.overlayVisible=false;
	}


  onChangeRangeDate() {
    this.dateRange.inicio = this.filtroDesde;
    this.dateRange.fin = this.filtroHasta;
    this.onChangeRangeHotMap(this.dateRange);
  }

  //#region  COPPONENTE rangeFilter
	onChangeRangeHotMap(dateRange){
		console.log('----------- EJECUTADO onChangeRangeHotMap');
		console.log(dateRange);


		const idEspacio = this.authenticationService.getIdEspacio();
		const timeCache = 0; // this.calculaTimeCache();
		const token = this.authenticationService.getToken();
		const that = this;

		const ahora = new Date();
		const horaFin = ahora.getHours() * 100 + ahora.getMinutes();
		let horaIni = horaFin;

		const fInicio = this.statsService.fechaToCubefec(dateRange.inicio);
		const fFin = this.statsService.fechaToCubefec(dateRange.fin) ;
		const rangoF = fInicio.fecha + ',' + fFin.fecha;

		// let group = 'Seccion,Usuario,Fecha';
		let group = 'Nodo,Usuario,Fecha';
		if (dateRange.lastMinutes != null){
			group += ',Hora';
			horaIni -= dateRange.lastMinutes;
		}

		const filtro = {
			Group: group,
			RangeFecha: rangoF,
			Espacio: idEspacio,
			Order: 'Nodo',
			cache: 'CUBEDASH1_RV_' + rangoF + idEspacio + timeCache,
			tipo: VISITAUSUARIOS
		};

		this.spinner.style.display = 'inherit';

		return this.statsService.statsVisitaCuenta(token, filtro, function (res) {
			that.spinner.style.display = 'none';
			if (dateRange.lastMinutes != null){
				const _finLista = [];
				for (const _i in res.lista){
					const _reg = res.lista[_i];
					const _hora = parseInt(_reg.Hora, 0);
					if (horaIni <= _hora && _hora <= horaFin){
						_finLista.push(_reg);
					}
				}
				res.lista = _finLista;
			}

			const agrupa = function(xs, key) {
				return xs.reduce(function(rv, x) {
				  (rv[x[key]] = rv[x[key]] || []).push(x);
				  return rv;
				}, {});
			  };

			const _nuevaLista = agrupa(res.lista, 'Seccion');

			const _nuevaLista2 = [];
			for (const _i in _nuevaLista){
				const total = _nuevaLista[_i].length;
				if (total === 0){
					continue;
				}

				_nuevaLista[_i][0].Total = total;
				_nuevaLista2.push(_nuevaLista[_i][0]);

			}

			that.visitasSeccion = _nuevaLista2;

			console.log('visitasSeccion: ');
			console.log(that.visitasSeccion);

			// TODO: Añadido 27/02/2020: Vamos a hacer una consulta por Nodos:
			const _nuevaListaNodos = agrupa(res.lista, 'Nodo');

			const _nuevaLista2Nodos = [];
			for (const _i in _nuevaListaNodos){
				const total = _nuevaListaNodos[_i].length;
				if (total === 0){
					continue;
				}

				_nuevaListaNodos[_i][0].Total = total;
				_nuevaLista2Nodos.push(_nuevaListaNodos[_i][0]);

			}

      that.visitasNodo = _nuevaLista2Nodos;
      that.cargaSecciones();
		});

	}
  //#endregion

  redondeo(num) {
    return Math.floor(num);
  }

  setScale(contenedorPlano, anchoMapa) {

      const escala = (contenedorPlano.offsetWidth - 30) / anchoMapa;
      const digits = 3;

      let n = escala - Math.pow(10, -digits) / 2;
      n += n / Math.pow(2, 53); // added 1360765523: 17.56.toFixedDown(2) === "17.56"
      return n.toFixed(digits);
  }

  setRadius(IconoContenidoScale) {
    this.radius = this.radius * IconoContenidoScale * 0.8;
  }

  getFirsAla() {
    if (this.alasDrop && this.alasDrop.length > 0) {
      return this.alasDrop[0].label;
    }
    return '';
  }

  cambiarPlanta(res) {
    // console.log(this.alas[res.value]);
    this.numAla = res.value;
    if (this.numAla >= this.seccionesPre.length) {
      this.numAla = 0;
    }
    this.cargaSecciones();
  }


  cargaSecciones() {
    console.log('--------------- EJECUTO cargaSecciones');
    let max = 0;
    let all = 0;

    this.seccionesHot = {};

    if (!this.visitasNodo) {
      return;
    }

    this.visitasNodo.forEach((element) => {
      this.seccionesHot[element.Seccion] = {
        Total: element.Total,
      };

      all += element.Total;
      if (max < element.Total) {
        max = element.Total;
      }
    });

    this.maxRange = max;

    this.visitasNodo.forEach((element) => {
      const perc = Math.floor((element.Total * 100) / max);
      const percAll = Math.floor((element.Total * 100) / all);
      this.seccionesHot[element.Seccion]['percentageAll'] = percAll;
      this.seccionesHot[element.Seccion]['percentage'] = perc;
      this.seccionesHot[element.Seccion]['color'] = this.pickHex(
        perc / 100
      );
    });

    this.nodosDeLaConsulta = [];
    this.visitasNodo.forEach((element) => {
      this.nodosDeLaConsulta.push(element);
    });

    this.cargarALAs('cargaSecciones');
  }

  cargarALAs(id: String) {
    console.log('--------------- EJECUTO cargarALAs');

    for (const key of Object.keys(this.puntos)) {
      this.puntos[key] = [];
    }

    //  const newId = id;
    const alaActual = this.listaAlasFormulario[this.numAla];
    let idAlaActual;

    // TODO: Revisar que se cambia bien el radius dependiendo de la escala del icono
    if (id === 'cargaSecciones'){
      idAlaActual = alaActual.Id;
      this.setRadius(alaActual.IconoContenidoScale);
    }

    const that = this;
    const entityManager = that.entityManagerProvider;
    let includes = 'NIVEL, ';
    includes = includes + 'SECCIONS.NODOS';
    this.spinner.style.display = 'inherit';
    return entityManager
      .getALAById(undefined, includes)
      .then(function (entidades) {
        if (!entidades || entidades.length < 1) {
        } else {
          let i = 0;

          if (id === 'ngOnInit') {
            that.alasDrop = [];
          }
          const _seccionesFormat = {};
		  entidades.sort( function(a, b) {
			if ( a.NIVEL.NivelVertical === b.NIVEL.NivelVertical) {
			  return a.Nomobre.localeCompare(b.Nomobre) ;
			}
			return a.NIVEL.NivelVertical - b.NIVEL.NivelVertical;
		  });
          entidades.forEach((element) => {
            const oAlaForm = new AlaFormulario(element);

            // Modificado Jeronimo 14/04/2020: Antes de cargar las alas en listaAlasFormulario, busco si el ala ya está en esa lista y si ya está no la vuelvo a añadir.
            const alaEncontradaAux = that.listaAlasFormulario.find(
              (a) => a.Id === oAlaForm.Id
            );
            if (alaEncontradaAux) {
              // No hago nada.
            } else {
              that.listaAlasFormulario.push(oAlaForm);
            }

            // that.listaAlasFormulario.push(oAlaForm);
            if (id === 'ngOnInit') {
              that.alasSVG.push(element.RutaImagen);
              that.seccionesPre.push(element.SECCIONS);
              that.alasDrop.push({
                label: element.Nomobre === element.NIVEL.Nombre ? element.Nomobre : element.Nomobre + ' - ' + element.NIVEL.Nombre,
                value: i,
              });

            }


            element.SECCIONS.forEach((_sec) => {
              _seccionesFormat[_sec.Id] = {
                nombre: _sec.Nombre,
              };

              _sec.NODOS.forEach((_nod) => {
                // x sería el índice del elemento en el array de nodosDeLaConsulta
                let enc = false;
                let x = 0;
                const tam = that.nodosDeLaConsulta.length;
                while (x < tam && !enc) {
                  if (
                    _nod.Id ===
                    that.nodosDeLaConsulta[x].Nodo
                  ) {
                    enc = true;
                  } else {
                    x = x + 1;
                  }
                }
                if (enc) {
                  const point = {
                    id: _nod.Id,
                    x: _nod.X,
                    y: _nod.Y,
                    value: that.nodosDeLaConsulta[x].Total,
                  };
                  // that.puntos.push(point);
                  if (that.puntos[element.RutaImagen] === undefined) {
                    that.puntos[element.RutaImagen] = [];
                  }
                  // Comprobamos si ya existia el punto y si existia le cambiamos el valor
                  const puntoEncontrado = that.puntos[element.RutaImagen].find(
                    (a) => a.id === point.id
                  );

                  if (puntoEncontrado) {
                    const index = that.puntos[element.RutaImagen].indexOf(puntoEncontrado);
                    that.puntos[element.RutaImagen][index] = point;
                  }
                  else {
                    that.puntos[element.RutaImagen].push(point);
                  }

                }
              });
            });
            that.puntos[element.RutaImagen] = Object.assign([], that.puntos[element.RutaImagen]);
            i++;
          });

          console.log(
            'DATOS DE LOS PUNTOS DE LOS NODOS A MOSTRAR EN EL MAPA:'
          );
          console.log(that.puntos);

          that.puntos = Object.assign([], that.puntos);
        }
        // Fin Else

        //  that.addSecciones(0);
        const alaNueva = that.alasSVG[that.numAla];

        if (alaNueva === that.pathPlano) {
          //  Si NO hemos cambiado de ala añadimos las secciones del Ala actual por si estas han cambiado
          that.addSecciones(that.numAla);
        } else {
          //  Si hemos cambiado de ala seteamos that.pathPlano que deipara cargarAla -> onSVGLoaded -> CargarSecciones
          that.pathPlano = alaNueva;
        }

        that.setCurrentTransform();
        setTimeout(function () {
          that.zoomIniciado = true;
        }, 2000);
        const token = that.authenticationService.getToken();
        const idEspacio = that.authenticationService.getIdEspacio();
        return that.sws
          .wsGetGeocalibracionAlasEspacio(token, idEspacio)
          .toPromise();
      })
      .then(function (resp: any) {
		console.log('GEOCALIBRACION_ALA: ', resp.GeocalibracionAlas);

        that.listaAlasFormulario.forEach((ala) => {
          const aux = resp.GeocalibracionAlas.find(
            (g) => g.IdAla === ala.Id
          );
          //  console.log(aux);
          ala.GEOCALIBRACION_ALA = aux;
        });
        const alaSeleccionada = that.listaAlasFormulario.find(
          (a) => a.RutaImagen === that.alasSVG[that.numAla]
        );
        that.anchoMapa =
          alaSeleccionada.GEOCALIBRACION_ALA !== undefined
            ? alaSeleccionada.GEOCALIBRACION_ALA.SVG_width
            : that.anchoMapa;
        that.altoMapa =
          alaSeleccionada.GEOCALIBRACION_ALA !== undefined
            ? alaSeleccionada.GEOCALIBRACION_ALA.SVG_height
            : that.altoMapa;
			console.log("Ancho: " , that.anchoMapa, "Alto: ", that.altoMapa);

        if (alaSeleccionada.GEOCALIBRACION_ALA === undefined) {
          console.error(
            'No existe GEOCALIBRACION_ALA para este ALA: ' +
            alaSeleccionada.id +
            ', si se quiere que el plano se vea bien ha de insertarse en base de datos una GEOCALIBRACION_ALA minimo con SVG_width y SVG_height'
          );
        }
        that.spinner.style.display = 'none';
      });
  }

  addSecciones(num) {
    console.log('*** Add Secciones ***');
    if (this.seccionesPre.length <= num) {
      return;
    }

    const _seccs = [];
    this.seccionesPre[num].forEach((seccion) => {
      let color = this.pickHex(0);
      let nombre = seccion.Nombre; // + '[' + seccion.Id + ']';
      if (this.seccionesHot && this.seccionesHot[seccion.Id]) {
        color = this.seccionesHot[seccion.Id].color;

        nombre +=
          ' ' +
          this.seccionesHot[seccion.Id].Total +
          ' visitas (' +
          this.seccionesHot[seccion.Id].percentageAll +
          '%) ';
      }

      const seccionCoordenadasPoligono: Array<
        Array<number>
        > = !seccion.CoordenadasPoligono
          ? null
          : JSON.parse(seccion.CoordenadasPoligono);
      const seccionPlano = new SeccionPlano(
        seccion.Id,
        nombre,
        seccionCoordenadasPoligono,
        1,
        1
      );
      seccionPlano.ENTIDAD = seccion;
      seccionPlano.fill = color;
      seccionPlano.stroke = color;
      seccionPlano.strokeWidth = '5';
      seccionPlano.hoverFill = color;
      seccionPlano.hoverStroke = color;
      _seccs.push(seccionPlano);
    });
    this.secciones = _seccs;
  }

  setCurrentTransform() {
    const _key = 'MAPPOS_' + this.alasSVG[this.numAla];
    const dat = localStorage.getItem(_key);

    let current: any = {};
    if (dat) {
      current = JSON.parse(dat);
    }

    if (!current.k) {
      return;
    }

    const _width = this.planoData.width; // DCANETE Revisar W
    const _height = this.planoData.height; // DCANETE Revisar H

    this.zoomAndCenterCoords = new zoomCenterCoordsPlano(
      0,
      0,
      0,
      0,
      current.k,
      [_width / 2, _height / 2]
    );
  }


  pickHex(weight) {
    let color1 = COLORES[0];
    let color2 = COLORES[1];
    let multi = 1;
    if (weight < 0.5) {
      color1 = COLORES[1];
      color2 = COLORES[2];
      multi = 2;
    }

    const w1 = weight * multi;
    const w2 = 1 - w1;

    const rgb = [
      Math.round(color1[0] * w1 + color2[0] * w2),
      Math.round(color1[1] * w1 + color2[1] * w2),
      Math.round(color1[2] * w1 + color2[2] * w2),
    ];

    return 'rgba(' + rgb[0] + ',' + rgb[1] + ',' + rgb[2] + ',0.8)';
  }

  descripcionInforme(event){
		console.log(event)
		this.positionDialogInfoInformeX = event.x;
		this.positionDialogInfoInformeY = event.y;
		this.dialogDescripcionInforme = !this.dialogDescripcionInforme;
	}

}



// WEBPACK FOOTER //
// C:/Users/adri9/Escritorio/admin-everpath/src/app/componentes/OcupacionChart/ocupacionChart.component.ts